import { render } from "./FormatFont.vue?vue&type=template&id=f71e633c"
import script from "./FormatFont.vue?vue&type=script&lang=js"
export * from "./FormatFont.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/FormatFont.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f71e633c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f71e633c', __exports__)) {
    api.reload('f71e633c', __exports__)
  }
  
  module.hot.accept("./FormatFont.vue?vue&type=template&id=f71e633c", () => {
    api.rerender('f71e633c', render)
  })

}


export default __exports__